import comp from "./AttachmentFeed";
export default comp;
